import type {
  IModifierSet,
  IProductSubItemProduct,
  IProductTax,
} from "@/api/interfaces/productLayouts";
import type { ApiRequestStatusMachine } from "@/store/apiRequestStatusMachine";

export enum ProductListItemType {
  SECTION = "SECTION",
  CATEGORY = "CATEGORY",
  ITEM = "ITEM",
  VARIABLE = "VARIABLE",
}

type ProductListItemBase = {
  id: number;
  uniqueId?: string;
  title: string;
  picture?: string;
  thumbnail?: string;
  bgColor?: string;
  inSequence?: boolean;
};

export type SectionListItem = ProductListItemBase & {
  type: ProductListItemType.SECTION;
  items: (CategoryListItem | ProductItem)[];
};

export type CategoryListItem = ProductListItemBase & {
  type: ProductListItemType.CATEGORY;
  items: ProductItem[];
};

type ProductItemFields = {
  shortTitle?: string;
  description?: string;
  category?: number;
  tax: IProductTax;
  netPrice: number;
  grossPrice?: number;
  minAge: number;
  modifiers?: IModifierSet;
  subItems?: IProductSubItemProduct[];
  isAgeRestricted: boolean;
  isFeatured: boolean;
  isDisabled: boolean;
  isCrossSells: boolean;
};

export type RegularProductItem = ProductListItemBase &
  ProductItemFields & {
    type: ProductListItemType.ITEM;
  };

export type VariableProductItem = ProductListItemBase &
  ProductItemFields & {
    type: ProductListItemType.VARIABLE;
    mainProductId: number;
  };

export type ProductItem = RegularProductItem | VariableProductItem;

export type ProductListItem = SectionListItem | CategoryListItem | ProductItem;

export type ProductLayoutData = {
  userId?: number;
  sections: SectionListItem[];
  products: ProductItem[];
};

export type ProductsState = {
  productLayout: ApiRequestStatusMachine<ProductLayoutData>;
};
